import { useQuery } from '@tanstack/react-query';
import { getPatientById, getPatientEvents } from '../api/patients';
import type { Patient, PatientEvent } from '../api/patients';

export function usePatient(patientId: number, options?: { enabled?: boolean }) {
  return useQuery<Patient, Error>({
    queryKey: ['patient', patientId],
    queryFn: () => getPatientById(patientId),
    enabled: (options?.enabled ?? true) && !!patientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function usePatientEvents(patientId: number, options?: { enabled?: boolean }) {
  return useQuery<PatientEvent[], Error>({
    queryKey: ['patientEvents', patientId],
    queryFn: () => getPatientEvents(patientId),
    enabled: (options?.enabled ?? true) && !!patientId,
    refetchInterval: 60 * 1000,
    staleTime: 30 * 1000,
  });
}
